<template>
    <div id="app">
        <Loading v-if="hide"></Loading>
        <router-view v-else/>
        <el-backtop style="color:var(--titleColor)"/>
        <Tip/>
    </div>
</template>

<script type="application/javascript">
import Tip from '@/components/Tip';
import Loading from '@/components/Loading';

export default {
    components: {Loading, Tip},
    data() {
        return {hide: true}
    },
    methods: {
    },
    mounted() {
        this.setAgentList();
        let lang = localStorage.lang;
        this.$i18n.locale = lang ? lang : 'zh_cn';
        let useFont = localStorage.useFont;
        this.$nextTick(() => {
            $(':root').css({
                "--color": "#6AAF20",
                "--useFont": useFont ? useFont : "'Avenir', Helvetica, Arial, sans-serif",
                "--currentColor": "#FF7F50",
                "--voltageColor": "#63A6C5",
                "--tempColor": "#F18565",
                "--avgColor": "#63A6C5",
                "--maxTempColor": "#F18565",
                "--minTempColor": "#64AFAC",
                "--menuColor": "#6AAF20",
                "--titleColor": "#228B22",
                "--fontColor": "#2C3E50",
                "--inputBgColor": "rgb(255,255,252)",
                "--bgColor": "rgb(242,242,242)",
            });
        });
        document.title = this.$t('pageLoading');
        this.axios.get('/user/ip/checkIP').then(response => {
            let result = response.data.data;
            if (!lang) this.$i18n.locale = result.areacode == 'CN' ? 'zh_cn' : 'en';
        });
        var that = this;
        var timer = setInterval(() => {
            if (document.readyState === 'complete') {
                document.title = this.$t('solarPoint');
                that.hide = false
                document.documentElement.scrollTop = 0;
                localStorage.setItem('scrollTop', 0);
                window.clearInterval(timer);
            }
        }, 300);
        this.$store.dispatch('setThemeColer');
    },
}
</script>
<style>
#app {
    font-family: var(--useFont);
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    text-align: center;
    color: #2C3E50;
}

span, p, div, .el-tooltip__popper {
    font-family: var(--useFont);
}

::selection {
    color: #FFFFFF;
    background: var(--titleColor);
    text-shadow: 0 0 3px rgba(0, 0, 0, 0.15);
}

.cv-preloader div {
    box-shadow: 0 5px 0 0 var(--titleColor);
}

.gs-w, .player, .preview-holder {
    transition: all 0.15s ease;
}

* {
    margin: 0;
    padding: 0;
}

img {
    user-select: none
}

i {
    transition: all 0.15s ease
}

span {
    transition: all 0.15s ease;
}

p {
    transition: all 0.15s ease;
}

button:hover > i {
    transform: scale(1.35);
    animation: button_hover 0.6s infinite;
    animation-iteration-count: 1
}

.swing-animation:hover {
    transform: scale(1.35);
    animation: button_hover 0.6s infinite;
    animation-iteration-count: 1
}

button:hover > .iconfont {
    display: inline-block;
    transform: scale(1.35);
    animation: button_hover 0.6s infinite;
    animation-iteration-count: 1
}

button:hover > span > i {
    transform: scale(1.35) translateX(-3px);
    animation: button_span_hover 0.6s infinite;
    animation-iteration-count: 1
}

button:hover > span > {
    transform: scale(1.35) translateX(-3px);
    animation: button_span_hover 0.6s infinite;
    animation-iteration-count: 1
}

@keyframes button_hover {
    0% {
        transform: scale(1) rotate(0deg);
    }
    20% {
        transform: scale(1.15) rotate(35deg);
    }
    40% {
        transform: scale(1.23) rotate(-50deg);
    }
    60% {
        transform: scale(1.35) rotate(25deg);
    }
    80% {
        transform: scale(1.4) rotate(-15deg);
    }
    100% {
        transform: scale(1.35) rotate(0deg);
    }
}

@keyframes button_span_hover {
    0% {
        transform: scale(1) rotate(0deg);
    }
    40% {
        transform: scale(1.13) translateX(-1px) rotate(-25deg);
    }
    60% {
        transform: scale(1.25) translateX(-2px) rotate(25deg);
    }
    80% {
        transform: scale(1.3) translateX(-3px) rotate(-10deg);
    }
    100% {
        transform: scale(1.25) translateX(-3.5px) rotate(0deg);
    }
}
.auto-scrollbar::-webkit-scrollbar-thumb {background: transparent;border-radius: 6px;}
.auto-scrollbar:hover::-webkit-scrollbar-thumb {background: #C0C4CC;}
.th-ellipsis {
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
}
</style>

